import {
    Avatar,
	Box,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemSecondaryAction,
	ListSubheader,
	SxProps,
	Theme,
} from "@mui/material";
import { blue } from '@mui/material/colors';
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo } from "react";
import { selectAuthenticatedUser, selectIsProfileOpened, selectUserGroupNames } from "../../features/authentication/auth.selector";
import { setProfileOpened } from "../../features/authentication/authSlice";
import CloseIcon from "@mui/icons-material/Close";
import FluidSelect from "./FluidSelect";
import { selectCurrentLocale } from "../../features/i18nSlice/i18n.selector";
import { setLocale } from "../../features/i18nSlice/i18n.slice";

const style: { [key: string]: SxProps<Theme> } = {
	drawer: {
		width: 500,
	},
	list: {
		width: "100%",
		maxWidth: 500,
		bgcolor: "background.paper",
	},
	header: {
		color: "#171D21",
		fontSize: 28,
		weight: 400,
	},
	progressWrapper: {
		display: "flex",
		justifyContent: "center",
	},
	role: {
		fontSize: 15,
		weight: 400,
		color: "#778C9B",
	},
	avatar: {
		marginLeft: "10px",
		fontSize: 20
	},
	region: {
		width: "100%",
		marginTop: "15px",
	},
	selectRegion: {
		width: "100%",
		marginBottom: "24px",
	},
};

export default function ProfileDrawer() {
	const dispatch = useDispatch();
	const isOpened = useSelector(selectIsProfileOpened);
	const authenticatedUser = useSelector(selectAuthenticatedUser);
    const groups = useSelector(selectUserGroupNames);
	const currentLocale = useSelector(selectCurrentLocale);

	const close = useCallback(() => {
		dispatch(setProfileOpened({ opened: false }));
	}, [dispatch]);

	useEffect(() => {
		const onBlur = () => close();
		window.addEventListener("blur", onBlur);
		return () => window.removeEventListener("blur", onBlur);
	}, [close]);

	const initials = useMemo(() => {
        return authenticatedUser?.name.split(" ").map((word) => word[0]).join("");
	}, [authenticatedUser]);
	const regions = [
		{ value: "eu", label: "EU", key: "eu" },
		{ value: "us", label: "US", key: "us" },
		{ value: "uk", label: "UK", key: "uk" }
	];
	return (
		<Drawer
			anchor={"right"}
			open={isOpened}
			onClose={close}
			PaperProps={{
				sx: style.drawer,
			}}
		>
			<List
				sx={style.list}
				component="nav"
				aria-labelledby="profile"
				subheader={
					<ListSubheader
						sx={style.header}
						component="div"
						id="profile-header"
					>
						Profile
						<ListItemSecondaryAction
							onClick={() =>
								dispatch(
									setProfileOpened({
										opened: false,
									})
								)
							}
						>
							<IconButton edge="end" aria-label="delete">
								<CloseIcon />
							</IconButton>
						</ListItemSecondaryAction>
					</ListSubheader>
				}
			>
				<ListItem>
                    <Avatar sx={{ bgcolor: blue[500] }}>{initials}</Avatar><Box sx={style.avatar}><b>{authenticatedUser?.name}</b></Box>
				</ListItem>
				<ListItem>
                    <Box sx={style.role}>{groups.join(", ")}</Box>
				</ListItem>

				<ListItem
					sx={{ display: "flex", justifyContent: "space-between" }}
				>
					<Box sx={style.region}>
						<FluidSelect
							sx={{
								...style.selectRegion,
							}}
							items={regions}
							label="Region"
							name="Region"
							value={currentLocale}
							onChange={(region: any) =>
								dispatch(setLocale(region))

							}
						/>
					</Box>
				</ListItem>
			</List>
		</Drawer>
	);
}
